export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registrační údaje"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uložit"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrzeno"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veřejně dostupné"])}
}